import { getCategoryFromInterest, getGroupFromFormdata } from '../ga4-tracking/custom-dimensions';
/**
 * converts a phone number to be e-146 compliant
 * @param {string} numberString
 * @returns {string} e.146 number-string
 */
const formatPhoneNumber = numberString => {
  return numberString
    .replace(/[()-\s]/g, '')
    .replace(/^00/, '+')
    .replace(/^0/, '+49');
};
/**
 * fetches contact details from a html form and formats the data
 * @param {HTMLElement} form - Form containing named inputs for the contact_details
 * @param {HTMLElement} expatPhonePrefix - prefix from intl-tel
 * @param {*} externalFields - fields not included in the form
 * @returns {{[key: string]: string}}
 */
const serializeForm = (form, expatPhonePrefix = undefined) => {
  const formValues = {};
  const formData = new FormData(form);
  for (const inputField of formData) {
    const name = inputField[0];
    const value = inputField[1];
    if (value !== '') {
      switch (name) {
        case 'phone_number':
          let phoneval = value;
          if (expatPhonePrefix && !value.startsWith('+')) {
            phoneval = `+${expatPhonePrefix.split('+').pop()}${value}`;
          }
          formValues[name] = formatPhoneNumber(phoneval);
          break;
        case 'date_of_birth':
        case 'ingress_date':
          formValues[name] = value.split('.').reverse().join('-');
          break;
        default:
          formValues[name] = value;
      }
    }
  }
  return formValues;
};
export default serializeForm;

export function serializeFormInterestFallback(form, expatPhonePrefix) {
  const formValues = serializeForm(form, expatPhonePrefix);
  if (formValues.interest && !formValues.insurance_category) {
    const insurance_category = getCategoryFromInterest(formValues.interest);
    if (insurance_category) {
      formValues.insurance_category = insurance_category;
    }
  }
  if (!formValues.insurance_group) {
    const insurance_group = getGroupFromFormdata(formValues);
    if (insurance_group) {
      formValues.insurance_group = insurance_group;
    }
  }
  return formValues;
}

export function serializeFormRaw(form) {
  const formValues = {};
  const formData = new FormData(form);
  for (const inputField of formData) {
    const name = inputField[0];
    const value = inputField[1];
    if (value !== '') {
      formValues[name] = value;
    }
  }
  return formValues;
}

export function parseSerializedData(formValues) {
  const parsedData = {};
  for (const [key, value] of Object.entries(formValues)) {
    switch (key) {
      case 'phone_number':
        let phoneval = value;
        const expatPhonePrefix = formValues.phone_prefix;
        if (expatPhonePrefix && !value.startsWith('+')) {
          phoneval = `+${expatPhonePrefix.split('+').pop()}${value}`;
        }
        parsedData[key] = formatPhoneNumber(phoneval);
        break;
      case 'date_of_birth':
      case 'ingress_date':
        parsedData[key] = value.split('.').reverse().join('-');
        break;
      case 'appointment':
        if (value.start && value.end) {
          parsedData[key] = value;
        } else {
          try {
            const appointment = JSON.parse(value);
            parsedData[key] = appointment;
          } catch (er) {
            console.warn("couldn't parse appointment formdata");
          }
        }
        break;
      case 'jaeg_reached':
        parsedData[key] = value === 'true';
        break;
      case 'customer_type':
        parsedData[key] = value === 'on' ? 'existing-customer' : 'new-customer';
        break;
      default:
        parsedData[key] = value;
    }
  }
  return parsedData;
}
